module.exports = __webpack_public_path__ + "img/kids.65004597.jpg";